"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TitleWrapper = exports.TitleContainer = exports.Title = exports.Subtitle = exports.ScrollExperienceWrapper = exports.ScrollExperienceText = exports.ScrollExperienceContainer = exports.ItemsContainer = exports.Image = exports.Headline = exports.ContainerDiv = exports.CardWrapper = exports.CardTitle = exports.CardSubtitle = exports.CardInfo = exports.CardCtaText = exports.CardContent = exports.CardCTA = exports.ArticleContainer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const setPosition = position => {
  switch (position) {
    case 'bottom':
      return (0, _styledComponents.css)`
        justify-content: flex-start;
        align-items: flex-end;
      `;
    case 'top':
      return (0, _styledComponents.css)`
        justify-content: flex-start;
        align-items: flex-start;
      `;
    default:
      return;
  }
};
const setOverlay = (overlay, aspectRatio, fullHeight) => {
  if (overlay) {
    return (0, _styledComponents.css)`
      object-fit: contain;
      @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
        width: ${fullHeight ? `calc(${100 * aspectRatio}vh)` : `calc(${100 * aspectRatio}vh - ${120 * aspectRatio}px);`};
      }
    `;
  } else {
    return (0, _styledComponents.css)`
      object-fit: contain;
      width: ${fullHeight ? `calc(${100 * aspectRatio}vh)` : `calc(${100 * aspectRatio}vh - ${120 * aspectRatio}px);`};
      @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
        width: 100%;
        height: auto;
      }
    `;
  }
};
const ArticleContainer = _styledComponents.default.div`
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
`;
exports.ArticleContainer = ArticleContainer;
const Wrapper = _styledComponents.default.div`
  position: relative;
  width: 100%;
  padding: 16px;
  height: initial;
  display: flex;
  justify-content: center;
  @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
    flex-direction: column;
  }

  @media (max-width: ${_breakpoints.BREAKPOINTS.xs}px) {
    padding: 0;
  }

  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    height: 100vh;
    overflow-x: hidden;
    overflow-y: hidden;
    padding: inherit;
  }
`;
exports.Wrapper = Wrapper;
const ContainerDiv = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: fit-content;
  ${props => props.headingOverlay && `
    align-items: center;
  `}
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    padding: ${props => props.fullHeight ? '0 120px 0 50px' : '50px 120px 0px 50px'};
    position: absolute;
    left: 0;
    flex-direction: row;
  }
  will-change: transform;
`;
exports.ContainerDiv = ContainerDiv;
const ItemsContainer = _styledComponents.default.div`
  display: flex;
  height: 100%;
  width: 100%;
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
exports.ItemsContainer = ItemsContainer;
const Image = _styledComponents.default.img`
  height: ${props => props.fullHeight ? '100vh' : props.headingOverlay ? '100%' : 'auto'};

  ${props => setOverlay(props.headingOverlay, props.aspectRatio, props.fullHeight)};
  transition: transform 0.25s ease-in-out;
  ${props => props.desktop && (0, _styledComponents.css)`
      @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
        display: none;
      }
    `}
  ${props => props.mobile && (0, _styledComponents.css)`
      width: 100%;
      @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
        display: none;
      }
    `}
  ${props => props.blackOverlay && (0, _styledComponents.css)`
      filter: brightness(70%);
    `};
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    height: 100%;
  }
`;
exports.Image = Image;
const Headline = _styledComponents.default.div`
  width: ${props => props.headingOverlay ? 'auto' : '-webkit-fill-available'};
  display: ${props => props.headingOverlay ? 'flex' : 'contents'};
  color: ${props => props.fontColor || 'black'};
  position: relative;
  margin-right: ${props => props.imagePadding ? '32px' : '0'};
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    flex-direction: column;
    margin: 0;
  }
`;
exports.Headline = Headline;
const TitleWrapper = _styledComponents.default.div`
  display: flex;
  ${props => props.headingOverlay && (0, _styledComponents.css)`
      position: absolute;
      z-index: 1;
      ${props => setPosition(props.textPosition)};
    `};
  width: 100%;
`;
exports.TitleWrapper = TitleWrapper;
const TitleContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: fit-content;
  margin: 40px;
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    margin: 20px;
    width: fit-content;
    height: fit-content;
  }
`;
exports.TitleContainer = TitleContainer;
const Title = _styledComponents.default.h2`
  text-transform: uppercase;
  line-height: 90%;
  max-width: 85%;
  margin: 0px;
  ${(0, _typography.setFont)({
  headline: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '30px',
  lg: '36px',
  xl: '48px'
})}
`;
exports.Title = Title;
const Subtitle = _styledComponents.default.p`
  line-height: 90%;
  text-transform: uppercase;

  ${(0, _typography.setFont)({
  headline: false
})}
  ${(0, _typography.setFontSizes)({
  xs: '16px',
  sm: '20px',
  xl: '24px'
})}
`;
exports.Subtitle = Subtitle;
const ScrollExperienceWrapper = _styledComponents.default.div`
  flex: 1;
  align-items: end;
  opacity: 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  div {
    width: 50%;
  }
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    opacity: 1;
  }
`;
exports.ScrollExperienceWrapper = ScrollExperienceWrapper;
const ScrollExperienceContainer = _styledComponents.default.div`
  width: 50%;
`;
exports.ScrollExperienceContainer = ScrollExperienceContainer;
const ScrollExperienceText = _styledComponents.default.span`
  font-family: 'univers-roman', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 90%;
  color: white;
  letter-spacing: -0.01em;
  text-transform: uppercase;
`;
exports.ScrollExperienceText = ScrollExperienceText;
const CardWrapper = _styledComponents.default.div`
  cursor: pointer;
  width: auto;
  height: fit-content;
  max-width: 100%;
  margin: ${props => props.imagePadding ? '0 0 0 16px' : '0'};
  overflow: hidden;
  position: relative;
  min-height: ${props => {
  return `calc(${100 / props.aspectRatio}vw - ${40 / props.aspectRatio}px);`;
}};
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    min-height: calc(100vh - 170px);
    min-width: ${props => {
  return `calc(${100 * props.aspectRatio}vh - ${170 * props.aspectRatio}px);`;
}};
  }
  @media (max-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    margin: 16px 0;
    height: ${props => {
  return `calc(${100 / props.aspectRatio}vw - ${40 / props.aspectRatio}px);`;
}};
  }
  ${props => props.hoverState && (0, _styledComponents.css)`
      &:hover {
        img {
          transform: scale(1.1);
        }
      }
    `};
`;
exports.CardWrapper = CardWrapper;
const CardInfo = _styledComponents.default.div`
  position: absolute;
  height: fit-content;
  width: -webkit-fill-available;
  margin: 20px;
  z-index: 1;
  color: ${props => props.fontColor || 'black'};
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    width: ${props => props.headingOverlay ? 'inherit' : '-webkit-fill-available'};
  }
`;
exports.CardInfo = CardInfo;
const CardContent = _styledComponents.default.div`
  height: 100%;
  width: -webkit-fill-available;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  ${props => setPosition(props.cardTextPosition)};
`;
exports.CardContent = CardContent;
const CardTitle = _styledComponents.default.h4`
  margin: 0;
  max-width: 100%;
  font-style: normal;
  line-height: 1em;
  letter-spacing: -0.01em;
  text-transform: uppercase;

  ${(0, _typography.setFont)({
  headline: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '24px',
  sm: '36px',
  xl: '48px'
})}
`;
exports.CardTitle = CardTitle;
const CardSubtitle = _styledComponents.default.p`
  font-style: normal;
  line-height: 110%;
  ${(0, _typography.setFont)({
  r: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '16px',
  lg: '20px'
})}
  text-transform: uppercase;
  letter-spacing: -0.01em;
`;
exports.CardSubtitle = CardSubtitle;
const CardCTA = _styledComponents.default.button`
  background: transparent;
  border: 1px solid;
  cursor: pointer;
  transition: 0.25s all;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    width: fit-content;
    padding: 0px 30px;
  }

  &:hover {
    background-color: white;
  }
`;
exports.CardCTA = CardCTA;
const CardCtaText = _styledComponents.default.p`
  font-family: 'univers-black', sans-serif;
  font-style: normal;
  font-weight: 900;
  line-height: 110%;
  transition: 0.25s all;
  text-transform: uppercase;
  text-align: center;
  margin: 0px;
  ${(0, _typography.setFont)({
  headline: true
})}
  ${(0, _typography.setFontSizes)({
  xs: '14px'
})}
  &:hover {
    color: black;
  }
`;
exports.CardCtaText = CardCtaText;
//# sourceMappingURL=styles.js.map